import React from 'react';
import PropTypes from 'prop-types';

import { TableRow, Collapse } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

import StyledTableCell from './styled-table-cell.component';

export default function EDTRow({
  id,
  crop,
  prop,
  death,
  injury,
  metric,
  narrative,
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TableRow
        onClick={() => setOpen(!open)}
        sx={{
          backgroundColor: open ? 'rgb(245,245,245)' : 'white',
          '&:hover': { backgroundColor: 'rgb(245,245,245)', cursor: 'pointer' },
        }}
      >
        <StyledTableCell sx={{ borderRight: '1px solid rgb(220,220,220)' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            <span
              style={{
                fontSize: '16px',
                marginLeft: '5px',
                position: 'relative',
                top: '3px',
              }}
            >
              {id}
            </span>
          </div>
        </StyledTableCell>
        {(metric === 'count' || metric === 'damageCrops') && (
          <StyledTableCell>${crop}</StyledTableCell>
        )}
        {(metric === 'count' || metric === 'damageProperty') && (
          <StyledTableCell>${prop}</StyledTableCell>
        )}
        {(metric === 'count' || metric === 'deaths') && (
          <StyledTableCell>{death}</StyledTableCell>
        )}
        {(metric === 'count' || metric === 'injuries') && (
          <StyledTableCell>{injury}</StyledTableCell>
        )}
      </TableRow>
      <TableRow>
        <StyledTableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={6}
        >
          <Collapse in={open} timeout='auto' unmountOnExit>
            <div>
              <div
                style={{ fontSize: 16, fontWeight: 'bold', marginTop: '4px' }}
              >
                Event Narrative
              </div>
              <div>{narrative}</div>
            </div>
          </Collapse>
        </StyledTableCell>
      </TableRow>
    </>
  );
}

EDTRow.propTypes = {
  id: PropTypes.string.isRequired,
  crop: PropTypes.string,
  prop: PropTypes.string,
  death: PropTypes.string,
  injury: PropTypes.string,
  metric: PropTypes.string.isRequired,
  narrative: PropTypes.string.isRequired,
};
